import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { posts } from '../data/site';
export function Blog() {
  return <section id="blog" className="border-b border-hairline bg-white" data-id="element-20" data-mp="hdyx8tvzpeer">
      <div className="mx-auto max-w-shell px-4 py-20 sm:px-8" data-id="element-21" data-mp="dcnftbn9rzhn">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-22" data-mp="db2nlsofgsmy">
          <div data-id="element-23" data-mp="8fn9czmicuq0">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted" data-id="element-24" data-mp="8bzf1y98o4a8">writing</p>
            <h2 className="mt-4 text-[clamp(1.9rem,3.6vw,3rem)] font-semibold leading-[1.02] tracking-tightest text-ink" data-id="element-25" data-mp="153jri8xlfy3c">
              From the team
            </h2>
          </div>
          <a href="#all-posts" className="group flex items-center gap-2 text-sm font-medium text-ink transition-colors duration-150 void-ease hover:text-void" data-id="element-26" data-mp="w2ddc6if2zd9">
            All posts
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 void-ease group-hover:translate-x-0.5" data-id="element-27" data-mp="3gv6wdgwl5gwm" />
          </a>
        </div>

        <ul className="mt-10 border-t border-hairline" data-id="element-28" data-mp="qdmm30c84fe8">
          {posts.map(post => <li key={post.title} data-id="element-29" data-mp="ug9lbmb852lg">
              <a href="#post" className="group grid items-start gap-3 border-b border-hairline py-7 transition-colors duration-150 void-ease hover:bg-[#fbfbfc] md:grid-cols-[160px_minmax(0,1fr)_40px] md:gap-8 md:px-2" data-id="element-30" data-mp="uegfuacckof1">
                <p className="font-mono text-xs text-muted" data-id="element-31" data-mp="6pnc3rphhc9v">
                  {post.date}
                  <span className="mt-1 block text-void" data-id="element-32" data-mp="bgncj6xtach4">{post.tag}</span>
                </p>
                <div data-id="element-33" data-mp="3tv4vhc7n9ugr">
                  <h3 className="text-xl font-semibold tracking-tight text-ink" data-id="element-34" data-mp="3tvo585n55cjp">{post.title}</h3>
                  <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted" data-id="element-35" data-mp="2nsf2zel5l1w">
                    {post.excerpt}
                  </p>
                </div>
                <ArrowRightIcon className="hidden h-5 w-5 self-center text-muted transition-transform duration-150 void-ease group-hover:translate-x-1 md:block" data-id="element-36" data-mp="3jz1l5j2n2piq" />
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}